import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTravelRelationStart,
  getTravelRelationSuccess,
  getTravelRelationFailure,
} from "../reducers/getTravelRelationReducer";
import axios from "axios";
import Cookies from "js-cookie";

export const getTravelRelation = createAsyncThunk(
  "getTravelRelation",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getTravelRelationStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Travel/GetBenificiaryRelation`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getTravelRelationSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getTravelRelationFailure(error.response.data.Message));

      throw error;
    }
  }
);
